'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
defineWellKnownSymbol('dispose');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.dispose.js
// module id = 742
// module chunks = 13